import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=c348d504&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=js&"
export * from "./Recaptcha.vue?vue&type=script&lang=js&"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=c348d504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c348d504",
  null
  
)

export default component.exports